import React from 'react';
import { motion } from 'framer-motion';
export function Story() {
  return <section className="py-24 md:py-32 bg-ink-light relative border-t border-white/5" id="historia" data-id="element-311" data-mp="1icf5gku0r4yn">
      <div className="container mx-auto px-6" data-id="element-312" data-mp="1n3dqfxpycr88">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-313" data-mp="1n3nidquk58gk">
          
          <motion.div className="relative h-[500px] lg:h-[700px] w-full rounded-2xl overflow-hidden" initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-314" data-mp="1s0x4awiqn1zn">
            <img src="https://cdn.magicpatterns.com/uploads/aryiDAzXxfjh2z5bUiYnoD/ChatGPT_Image_18_may_2026,_10_16_38.png" alt="Freddy caminando en la ciudad de noche" className="w-full h-full object-cover object-top grayscale-[20%] contrast-125" data-id="element-315" data-mp="14bckycioa2pu" />
            <div className="absolute inset-0 bg-ink/20" data-id="element-316" data-mp="2jvhcn1tt034a"></div>
          </motion.div>

          <motion.div className="max-w-xl" initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-317" data-mp="191jp5saynh14">
            <h2 className="text-3xl md:text-5xl font-serif text-ivory-bright mb-8 leading-tight uppercase" data-id="element-318" data-mp="v18wqku05udu">
              YO TAMBIÉN TUVE QUE EMPEZAR DESDE CERO.
            </h2>

            <div className="space-y-6 text-muted font-light leading-relaxed text-lg" data-id="element-319" data-mp="lbz1wx7rxxm1">
              <p className="text-ivory" data-id="element-320" data-mp="gd4knzpggh41">Soy Freddy Pimentel.</p>
              <p data-id="element-321" data-mp="gbbd8i70psuz">A los 13 años cargaba ladrillos para ayudar a sostener a mi familia.</p>
              <p data-id="element-322" data-mp="bg4fdr0fjidz">Años después construí negocios, estabilidad y una vida diferente. Hasta que tuve que dejarlo todo atrás.</p>
              <p data-id="element-323" data-mp="7eitxh9txvs6">Cuando llegué a Argentina tuve que comenzar nuevamente desde cero.</p>
              <p data-id="element-324" data-mp="2fpqkho9bl5q">En ese proceso entendí algo que transformó mi manera de ver la vida:</p>
            </div>

            <motion.div className="my-10 py-8 border-y border-gold/30 relative" initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} data-id="element-325" data-mp="3oxri2bmb3byl">
              <p className="font-serif text-2xl md:text-3xl text-ivory-bright text-center leading-snug" data-id="element-326" data-mp="bgiddvui3dux">
                EL PUNTO CERO NO ES EL FINAL.<br data-id="element-327" data-mp="gejwggrxfd6e" />
                <span className="text-gold italic" data-id="element-328" data-mp="gf22g54e55ri">ES EL LUGAR DONDE PUEDE COMENZAR LA RECONSTRUCCIÓN.</span>
              </p>
            </motion.div>

            <div className="space-y-6 text-muted font-light leading-relaxed text-lg" data-id="element-329" data-mp="6pikd1oi5fxp">
              <p data-id="element-330" data-mp="ufctp99m4md7">No fue una motivación vacía la que me ayudó a avanzar. Fue aprender a trabajar mi mentalidad, reconstruirme emocionalmente, recuperar dirección y volver a conectar con Dios y conmigo mismo.</p>
              <p className="text-ivory font-medium" data-id="element-331" data-mp="2jw8ff7xu186i">Hoy pongo esa experiencia al servicio de personas que están atravesando una etapa de cambio y quieren volver a tomar dirección.</p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>;
}